import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMedicalBriefcase = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "var(--icon-color, currentColor)",
	strokeWidth: 1.5,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M12 11v4" }),
		/* @__PURE__ */ _jsx("path", { d: "M14 13h-4" }),
		/* @__PURE__ */ _jsx("path", { d: "M16 6V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2" }),
		/* @__PURE__ */ _jsx("path", { d: "M18 6v14" }),
		/* @__PURE__ */ _jsx("path", { d: "M6 6v14" }),
		/* @__PURE__ */ _jsx("rect", {
			width: 20,
			height: 14,
			x: 2,
			y: 6,
			rx: 2
		})
	]
});
export default SvgMedicalBriefcase;
